import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuditLog } from '../../../../models/audit-log.model';
import { RegulationsService } from '../../../../services/api/general-settings/regulations.service';
import { RegulationsCategoriesComponent } from '../components/regulations-categories/regulations-categories.component';
import { RegulationsFormComponent } from '../components/regulations-form/regulations-form.component';
import { TranslationsDetailsComponent } from '../components/translations-details/translations-details.component';
import { RegulationsChangesLogComponent } from '../components/regulations-logs-change/regulations-changes-logs.component';

@Component({
  selector: 'app-regulations-detail-page',
  imports: [RegulationsFormComponent, TranslationsDetailsComponent, RegulationsCategoriesComponent, RegulationsChangesLogComponent],
  templateUrl: './regulations-detail-page.component.html',
  styleUrl: './regulations-detail-page.component.scss'
})
export class RegulationsDetailPageComponent implements OnInit, OnDestroy {
  regulationId!: number;
  regulation?: any;
  translations?: any;
  category?: any;
  auditLogs: AuditLog[] = [];
  readonly: boolean;
  isLoadingAuditLogs: boolean = false;

  private destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private regulationsService: RegulationsService
  ) {
    this.readonly = true;
  }

  ngOnInit(): void {
    this.regulationId = Number(this.route.snapshot.paramMap.get('regulationId'));
    if (this.regulationId) {
      this.loadData(this.regulationId);
      this.loadAuditLogs(this.regulationId);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadData(regulationId: number): void {
    this.regulationsService.detail(regulationId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          this.regulation = response.data?.regulation;
          this.translations = response.data?.regulation?.regulationArticles;
          this.category = response.data?.regulation?.categories;
        },
        error: (error: any) => {
          console.error('Error loading data:', error);
        }
      });
  }

  loadAuditLogs(regulationId: number): void {
    this.isLoadingAuditLogs = true;
    this.regulationsService.getChangesLog(regulationId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          this.auditLogs = response.data?.auditLogs || [];
          this.isLoadingAuditLogs = false;
        },
        error: (error: any) => {
          console.error('Error loading changelog:', error);
          this.auditLogs = [];
          this.isLoadingAuditLogs = false;
        }
      });
  }
}
